module.exports = __webpack_public_path__ + "/build/web/svg/ic_close-black.7bc626ef4b1ebb3233a13d8f368ce973.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/ic_close-black.svg
// module id = 218
// module chunks = 13